import React, { memo } from 'react';
import { IconWrapper } from 'src/modules/common/icons/IconWrapper';

export const FilterIcon = memo(() => (
  <IconWrapper>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fill="currentColor"
        d="M10.725 16.7V16h2.525v.7zM7.05 12.35v-.7h9.875v.7zM4.3 8v-.7h15.4V8z"
      />
    </svg>
  </IconWrapper>
));
